<template>
  <b-card
    class="completed-checklist-card shadow atm-rounded h-100"
    header-class="bg-light-lavender"
  >
    <section v-if="completed" class="d-flex flex-column text-center gap-2 h-100">
      <section
        class="d-flex flex-column gap-2 text-light bg-light-lavender atm-rounded-top px-4 py-4 h-50"
      >
        <p>Checklists Completed to date:</p>
        <p class="font-weight-bolder h3">{{ fireEmoji }}{{ completed.checksCompleted }}</p>
      </section>
      <section class="d-flex gap-2 px-4 py-4 h-50">
        <p>Last checklist completed:</p>
        <p class="font-weight-bold">{{ completed.days }} days ago</p>
      </section>
    </section>
  </b-card>
</template>

<script>
import { fireEmoji } from '@/dashboard/constants';
export default {
  props: {
    checklistsCompleted: Object,
  },
  data() {
    return {
      completed: {},
      fireEmoji,
    };
  },
  watch: {
    checklistsCompleted: {
      handler(newVal) {
        if (newVal) this.completed = newVal;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-light-lavender {
  background-color: #8f98ff;
}

.completed-checklist-card {
  & .card-body {
    padding-top: 0px;
  }

  & section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  & section p {
    margin: 0;
  }
}
</style>
